import { cascadeApi } from "api/TenantSlug/Cascade/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";
import { useMemo } from "react";

import CascadeData = App.Data.CascadeData;

interface UseCascadeSelectOptionsParams {
    offerId?: string;
}

export const useCascadeSelectOptions = ({ offerId }: UseCascadeSelectOptionsParams = {}) => {
    const queryParams = useMemo(
        () =>
            offerId
                ? {
                      include_trashed: "true",
                      filter: {
                          filter: {
                              offer_id: offerId,
                          },
                          sort: "title",
                      },
                  }
                : {
                      include_trashed: "true",
                      filter: {
                          sort: "title",
                      },
                  },
        [offerId]
    );

    const cacheKey = offerId ? `cascade-select-${offerId}` : "cascade-select";

    return useSelectOptions<CascadeData>({
        apiFunction: (payload) => cascadeApi.index(payload),
        dataKey: "cascades",
        cacheKey,
        queryParams,
        mapToOption: (cascade) => ({
            label: cascade.title,
            value: cascade.id,
        }),
    });
};
